import { z } from 'zod';
import { IC_GUIDELINES_TABLE_IDS } from './ic-guidelines-v2.tables.types';
export const guidelineThresholdsSchema = z
    .object({
    hard_upper: z.number().nullable(),
    hard_lower: z.number().nullable(),
    soft_upper: z.number().nullable(),
    soft_lower: z.number().nullable(),
})
    .refine((thresholds) => Object.values(thresholds).some((threshold) => typeof threshold === 'number'), 'Thresholds must have at least one value present');
export const guidelineSchema = z.object({
    id: z.number().nullable(),
    name: z.string().min(1),
    description: z.string().nullable(),
    funds: z.array(z.number().int()).min(1),
    table: z.enum(IC_GUIDELINES_TABLE_IDS),
    value_column: z.string().min(1),
    aggregation_function: z.literal('sum').nullable(),
    identifiers: z.record(z.string(), z.string().min(1)).nullable(),
    threshold_type: z.union([z.literal('unit'), z.literal('percentage'), z.literal('basis_points')]),
    thresholds: guidelineThresholdsSchema,
    is_active: z.boolean(),
});
export const createGuidelineSchema = z.object({
    guideline: guidelineSchema,
});
export const updateGuidelineSchema = z.object({
    guideline: guidelineSchema,
});
export const deleteGuidelineSchema = z.object({
    guideline_id: z.number(),
});
